import { effect, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { UserPermission, userPermissionFromGroupId } from '../constants/permission.constants.enum';
import { MicrosoftGraphService } from './microsoft-graph.service';
import { catchError, filter, map, Observable, of } from 'rxjs';
import { LoadingService } from './loading.service';
import { environment } from '../../../environments/environment';
import { API_ENDPOINT, USE_BACKEND_AVATAR_API } from '../constants/app.constants';
import { HttpClient } from '@angular/common/http';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  name = signal('');
  id = signal('');
  username = signal('');
  jobTitle = signal('');
  photo: WritableSignal<string | undefined> = signal(undefined);
  authenticated = signal<boolean>(false);
  permissions = signal<UserPermission[]>([]);
  permission$:Observable<UserPermission[]>;

  userInfoUri = environment.apiConfig.apiEndpointBase + API_ENDPOINT.USER_INFO + '?email=';
  avatarUri = environment.apiConfig.apiEndpointBase + API_ENDPOINT.AVATAR + '?userId=';

  constructor(
    private authService: MsalService,
    private graphService: MicrosoftGraphService,
    private loader: LoadingService,
    private http: HttpClient
  ) {
    effect(() => {
      const permissions = this.permissions();
      if (permissions.length) {
        // console.log(`user permission Ids: ${permissions}`);
        // console.log(`user is ISADMIN: ${permissions.includes(UserPermission.ISADMIN)}`);
        this.loader.loading.set(false);
      }
    });
    this.permission$ = toObservable(this.permissions).pipe(
      filter((p) => p.length > 0)
    );
   }

  setUserInfo(account: any) {
    account?.name && this.name.set(account.name);
    account?.username && this.username.set(account.username);
    this.authenticated.set(!!account);
    this.http.get(this.userInfoUri + this.username()).pipe(
      map((resp: any) => resp.data),
      catchError(() => of(null))
    ).subscribe(userInfo => {
      if (userInfo) {
        this.id.set(userInfo.userId);
        this.jobTitle.set(userInfo.jobTitle);
        this.name.set(userInfo.displayName);
      }
    });
    if (USE_BACKEND_AVATAR_API) {
      this.http.get(this.avatarUri + this.username()).pipe(
        map((r: any) => r.data)
      ).subscribe(data => {
        if (data.imageData) {
          this.photo.set(`data:image/png;base64,${data.imageData}`);
        } else if (data.message) {
          console.log('avatar:', data.message);
        }
      });
    } else {
      this.graphService.getAvatar().pipe(
        map((res: ArrayBuffer) => new Blob([res], { type: 'image/jpeg' }))
      ).subscribe(blob => {
        console.log(blob)
        this.photo.set(URL.createObjectURL(blob));
      });
    }
    this.graphService.groups
      .pipe(
        // transform groupIds to UserPermission constants
        map(groupIds => groupIds.map(userPermissionFromGroupId).filter(p => !!p)),
        // uncomment for testing permissions
        // map(perms => [UserPermission.Explanation, UserPermission.ISADMIN]),
        // map(perms => [UserPermission.User, UserPermission.Explanation])
        // map(perms => [UserPermission.EEProject]),
      )
      .subscribe(this.permissions.set)
  }

  logout(popup?: boolean) {
    if (popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: '/logged-out',
      });
    } else {
      this.authService.logoutRedirect();
    }
  }
}
